/**
 * Unified casting / remote-playback events (UI + plugins + lab diagnostics).
 */
export var CastingEvent = Object.freeze({
  PROVIDERS_CHANGED: "CastingProvidersChanged",
  AVAILABILITY_CHANGED: "CastingAvailabilityChanged",
  DEVICES_CHANGED: "CastingDevicesChanged",
  SESSION_STARTING: "CastingSessionStarting",
  SESSION_STARTED: "CastingSessionStarted",
  SESSION_ENDING: "CastingSessionEnding",
  SESSION_ENDED: "CastingSessionEnded",
  STATE_SYNC: "CastingStateSync",
  ERROR: "CastingError",
  FAILOVER_LOCAL: "CastingFailoverLocal",
  TARGET_CHANGED: "CastingTargetChanged",
  CAPABILITY_CHANGED: "CastingCapabilityChanged",
});

export var CastingTarget = Object.freeze({
  LOCAL: "local",
  REMOTE: "remote",
});

export var CastingConnectionState = Object.freeze({
  DISCONNECTED: "disconnected",
  CONNECTING: "connecting",
  CONNECTED: "connected",
  ERROR: "error",
});

/**
 * Explicit per-provider capability / lifecycle state.
 * UI must never show "Connected" unless state is connected|playing|paused
 * from a real provider session — never invent devices or fake success.
 */
export var CastingCapabilityState = Object.freeze({
  AVAILABLE: "available",
  DISCOVERING: "discovering",
  CONNECTING: "connecting",
  CONNECTED: "connected",
  PLAYING: "playing",
  PAUSED: "paused",
  DISCONNECTED: "disconnected",
  UNSUPPORTED: "unsupported",
  REQUIRES_RECEIVER_APP: "requires_receiver_app",
  REQUIRES_NATIVE_APP: "requires_native_app",
  ERROR: "error",
});

/**
 * App-level Cast UI states (UniversalCastButton / session chrome).
 * Reflect real provider state — never fake success.
 */
export var CastingUiState = Object.freeze({
  UNAVAILABLE: "unavailable",
  AVAILABLE: "available",
  CONNECTING: "connecting",
  CONNECTED: "connected", // connected/idle — session up, no media (or idle)
  CASTING: "casting",
  DISCONNECTED: "disconnected",
  ERROR: "error",
  REQUIRES_RECEIVER_APP: "requires_receiver_app",
  REQUIRES_NATIVE_APP: "requires_native_app",
  UNSUPPORTED: "unsupported",
});

export default CastingEvent;
